import React from 'react';
import { useSelector } from 'react-redux';
import { selectRoute } from "../../../util/store/selectors";
import PopupEditRoute from "../_component/PopupEditRoute";
import { RouteMode } from "../constatns";
import RouteView from "../RouteView";
import styles from './style.module.scss';
import WrapperRoute from "./WrapperRoute";

interface IProps {
}

const Content: React.FC<IProps> = () => {
    const mode = useSelector(selectRoute.mode);
    const isShow = mode === RouteMode.EDIT;

    return <WrapperRoute width='460px'>
        <div className={styles['wrapper-controller']}>
            <div className={styles['controller-content']} data-show={isShow} >
                <div className={styles.screen} data-hide={isShow}>
                    <RouteView />
                </div>
                <div className={styles.screen} data-hide={!isShow}>
                    <PopupEditRoute />
                </div>
            </div>
        </div>
    </WrapperRoute>;
};

export default Content;

